import React from "react";
import { Box, Button } from "@mui/material";
import { Modal } from "ui-components/modal";
import { useState } from "react";
import { $modals } from "store/modals";
import { observer } from "mobx-react-lite";
import { $reviews } from "store/reviews/reviews";

const DeleteReviewModal = observer(() => {
  const [btnLoading, setBtnLoading] = useState(false);
  const id = $modals.params;
  const onSubmit = () => {
    setBtnLoading(true);
    $reviews
      .remove(id)
      .then(() => {
        $reviews.fetchReviews();
      })
      .finally(() => {
        setBtnLoading(false);
        $modals.close();
      });
  };

  return (
    <Modal
      title="Удаление отзыва"
      subheader={<>Вы действительно хотите отзыв?</>}
    >
      <Box sx={{ textAlign: "right" }}>
        <Button disabled={btnLoading} variant="contained" onClick={onSubmit}>
          Удалить
        </Button>
      </Box>
    </Modal>
  );
});

export default DeleteReviewModal;
